export const HubSpotPartnersTypeDecorator = {
  url() {
    return `signup-hubspot/hubspot-partners`;
  },

  query() {
    return {};
  }

};